import { render, staticRenderFns } from "./DNABudgets.vue?vue&type=template&id=425008f4&"
import script from "./DNABudgets.vue?vue&type=script&lang=js&"
export * from "./DNABudgets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports